import { bindActionCreators } from 'redux';
import React, { createContext, useContext, useEffect, useState } from 'react';
import shallowEqual from './shallowEqual';
export var ReduxContext = createContext({});
export var Provider = function Provider(_ref) {
  var store = _ref.store,
      children = _ref.children;
  return React.createElement(ReduxContext.Provider, {
    value: store
  }, children);
};
export var useReduxCore = function useReduxCore(selector, _ref2) {
  var _ref2$pure = _ref2.pure,
      pure = _ref2$pure === void 0 ? false : _ref2$pure,
      shouldHooksUpdate = _ref2.shouldHooksUpdate;
  var context = useContext(ReduxContext);

  var _useState = useState(selector(context.getState())),
      state = _useState[0],
      setState = _useState[1];

  function handleChange() {
    var updateState = selector(context.getState()); // if shouldHooksUpdate not set and pure is false, update state every time

    var shouldUpdate = typeof shouldHooksUpdate === 'function' ? shouldHooksUpdate(updateState, state) : true;

    if (pure) {
      shouldUpdate = !shallowEqual(updateState, state);
    }

    if (shouldUpdate) {
      setState(updateState);
    }
  }

  useEffect(function () {
    return context.subscribe(handleChange);
  }, [state]);
  return [state, context.dispatch];
};

var defaultSelector = function defaultSelector(state) {
  return state;
};

export var useRedux = function useRedux(originSelector, actions, options) {
  if (options === void 0) {
    options = {};
  }

  var selector = typeof originSelector !== 'function' ? defaultSelector : originSelector;

  var _useReduxCore = useReduxCore(selector, options),
      state = _useReduxCore[0],
      dispatch = _useReduxCore[1];

  if (typeof actions === 'undefined' || actions === null) {
    return [state, dispatch];
  }

  var boundActions = typeof actions === 'function' ? actions(dispatch) : bindActionCreators(actions, dispatch);
  return [state, boundActions];
};